import { render } from "./RecomendadosView.vue?vue&type=template&id=70c062b2"
import script from "./RecomendadosView.vue?vue&type=script&lang=js"
export * from "./RecomendadosView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__